import gql from 'graphql-tag';

export default gql`
  mutation AUTH_UPDATE_PROFILE($inscriptions: [InscriptionInput!]!) {
    inscriptionCreate(inscriptions: $inscriptions) {
      count
    }
  }
`
